import axios from "axios";
import { baseUrl } from "./baseUrl";

export const fetchOrderInvoicePdf = async (orderId) => {
  const response = await axios.get(`${baseUrl}/orders/${orderId}/pdf`);
  return response?.data?.data || {};
};

export const fetchOrderInvoiceShare = async (orderId) => {
  const response = await axios.get(`${baseUrl}/orders/${orderId}/invoice-share`);
  return response?.data?.data || {};
};

export const downloadOrderInvoicePdf = async (orderId) => {
  const { pdf_url: pdfUrl, filename } = await fetchOrderInvoicePdf(orderId);

  if (!pdfUrl) {
    throw new Error("PDF not available");
  }

  const link = document.createElement("a");
  link.href = pdfUrl;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  if (filename) {
    link.download = filename;
  }
  document.body.appendChild(link);
  link.click();
  link.remove();

  return { pdfUrl, filename };
};
